import script from "./TeamsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamsTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__